export function pointNames(text) {
  if (!text || typeof DOMParser === "undefined") return [];
  const doc = new DOMParser().parseFromString(text, "text/xml");
  const nodes = [...doc.querySelectorAll("Placemark > name, wpt > name")];
  return nodes.map((node) => (node.textContent || "").trim()).filter(Boolean);
}
